import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { MerakiNetwork } from '@app/shared/models/meraki/meraki-network.model';


@Component({
    selector: 'app-meraki-network-card',
    templateUrl: './network-card.component.html',
    styleUrls: ['./network-card.component.css'],
    standalone: false
})
export class MerakiNetworkCardComponent implements OnInit, OnDestroy {
    @Input() network: MerakiNetwork;

    constructor() {}

    ngOnInit() {}
    ngOnDestroy() {}


}